import apiCommonCategory from "@/api/common-category";
import {post} from "@/utils/request";

export default class apiBkUserLibrary extends apiCommonCategory{
  static module = 'bk_user_library'

  static async import(url){
    return post('/home/bk_user_library/import', {url})
  }

}
